const Defaults = {id: ''};
const DataAttributes = ['id'];

class DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;

  static query(params = {}, url = null, dataOnly=false) {
    return this.resource.query(params, url).then((data) => {
      const result = {};
      if (url || dataOnly) {
        return data.items;
      } else {
        result.items = (data.items).map(item => new this(item));
      }
      if (data.paging) {
        result.paging = data.paging;
        return result;
      }
      return result.items;
    });
  }

  static get(id, params={}) {
    return this.resource.get(id, params).then((data) => new this(data));
  }

  constructor(data) {
    this.data = data || {};
  }

  updateFrom(data) {
    Object.keys(data).forEach((key) => {
      this[key] = typeof(data[key]) == 'undefined' || data[key] == null ? '' : data[key];
    });
    return this;
  }

  save() {
    const patch = {};
    this.constructor.DataAttributes.forEach((attr) => {
      // if (typeof this[attr] === 'object' || attr === 'id' || this[attr] !== this.data[attr]) {
      if (attr === 'id' || this.hasOwnProperty(attr)) {
        patch[attr] = this[attr];
      }
    });
    if (Object.keys(patch).length === 0) {
      return new Promise((resolve) => resolve(this));
    }
    if (this.id && this.id !== 'new') { // Update object
      patch.id = this.id;
      
      return this.constructor.resource.update(patch).then(data => new this.constructor(data));
    } else { // create Object
      const {id, ...dataToSave} = patch;
      return this.constructor.resource.post(dataToSave).then(data => new this.constructor(data));
    }
  }

  delete() {
    this.deleting = true;
    if (!this.id || this.id === 'new') {
      return new Promise((resolve) => {
        this.deleting = false;
        resolve(this.id);
      });
    }
    return this.constructor.resource.delete(this).then((obj) => {
      this.deleting = false;
      return obj.id;
    });
  }

  isFieldChanged(fieldName) {
    return this[fieldName] !== this.data[fieldName]
  }

}

export default DataModel;
